module.exports = __webpack_public_path__ + "img/vector.96393bfd.svg";